const { REACT_APP_DOMAIN } = process.env;

/**
 * Takes in an array of FHIR Device objects and returns an array of device objects.
 * @param {Array<DeviceData>} data - the array of device data to convert into device objects.
 * @returns {Array<Device>} - an array of device objects.
 */
export function fDevices(data) {
  const deviceArray = [];
  data.forEach((element) => {
    const deviceObj = fDevice(element);
    deviceArray.push(deviceObj);
  });
  return deviceArray;
}

/**
 * It takes a FHIR Device resource and returns a JavaScript object with the same data.
 * @param {object} element - the object that is being passed in
 * @returns {object} - An object with the following properties:
 * id, status, manufacturer, serialNumber, patient, location, url, type, statusReason,
 *  deviceName_name, deviceName_type
 */
export function fDevice(element) {
  let deviceObj = {
    id: element.id,
    status: element.status || '',
    statusReason: '',
    manufacturer: element.manufacturer || '',
    serialNumber: element.serialNumber || '',
    patient: element.patient?.reference?.split('/')[1] || '',
    location: element.location?.reference?.split('/')[1] || '',
    url: element.url || '',
    type: element.type ? element.type.text : '',
  };

  if (Array.isArray(element.statusReason)) {
    deviceObj = {
      ...deviceObj,
      statusReason: element.statusReason[0].coding[0].code,
    };
  }

  if (Array.isArray(element.deviceName)) {
    deviceObj = {
      ...deviceObj,
      deviceName_name: element.deviceName[0]?.name || '',
      deviceName_type: element.deviceName[0]?.type || '',
    };
  }

  if (Array.isArray(element.extension)) {
    element.extension.forEach((ext) => {
      if (ext.url === `${REACT_APP_DOMAIN}/StructureDefinition/patient-lifeline-monitor-config`) {
        ext.extension?.forEach((e) => {
          if (e.url === 'notification') {
            deviceObj = {
              ...deviceObj,
              notification: e.valueBoolean,
            };
          } else if (e.url === 'notificationSound') {
            deviceObj = {
              ...deviceObj,
              notificationSound: e.valueString,
            };
          } else if (e.url === 'maxslot') {
            deviceObj = {
              ...deviceObj,
              maxslot: e.valueInteger,
            };
          }
        });
      }

      if (ext.url === `${REACT_APP_DOMAIN}/StructureDefinition/patient-lifeline-monitor-patient`) {
        let position;
        let patient;
        ext.extension.forEach((e) => {
          if (e.url === 'position') {
            position = e.valueInteger;
          } else if (e.url === 'patient') {
            patient = e.valueReference.reference.split('/')[1];
          }
        });

        deviceObj[`slot${position}`] = patient;
      }

      if (ext.url === `${REACT_APP_DOMAIN}/StructureDefinition/device-mybeshie-step`) {
        deviceObj = {
          ...deviceObj,
          mybeshieStep: ext.valueInteger,
        };
      }

      if (ext.url === `${REACT_APP_DOMAIN}/StructureDefinition/device-mybeshie-position-marker`) {
        if (!deviceObj.markers) {
          deviceObj.markers = {};
        }

        let name;
        let positionX;
        let positionY;
        let orientation;
        ext.extension.forEach((e) => {
          if (e.url === 'position_x') {
            positionX = e.valueDecimal;
          } else if (e.url === 'position_y') {
            positionY = e.valueDecimal;
          } else if (e.url === 'orientation') {
            orientation = e.valueDecimal;
          } else if (e.url === 'name') {
            name = e.valueString;
          }
        });

        deviceObj.markers[name] = {
          positionX,
          positionY,
          orientation,
        };
      }
    });
  }

  return deviceObj;
}
